import React, { useState } from 'react';
import { Container, Row, Col, Card, Spinner } from 'react-bootstrap';
import UserTable from '../../Components/UserTable';  // Import the UserTable component we created earlier
import MainLayout from '../../Components/Layout/MainLayout/MainLayout';

const Users = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  return (
    <MainLayout>
    <Container fluid className="py-4">
      {/* Page Header */}
      <Row className="mb-4">
        <Col>
          <h1 className="h3 mb-2">User Management</h1>
          <p className="text-muted">View and manage system users</p>
        </Col>
      </Row>

      {/* Main Content */}
      <Row>
        <Col>
          <Card>
            <Card.Header className="d-flex justify-content-between align-items-center">
              <div>
                <Card.Title className="mb-0">Users</Card.Title>
              </div>
              {loading && (
                <Spinner 
                  animation="border" 
                  variant="primary" 
                  size="sm"
                />
              )}
            </Card.Header>
            <Card.Body>
              {error ? (
                <div className="text-danger mb-3">
                  Error loading users: {error}
                </div>
              ) : (
                <UserTable 
                  onLoadingChange={setLoading}
                  onError={setError}
                />
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
    </MainLayout>
  );
};

export default Users;